import { RootState } from 'store/index';

export const programColumnsSelector = (state: RootState) => state.programs.programColumns;
export const hasInitializedColumnsSelector = (state: RootState) => state.programs.hasInitialized;
